<template>
  <div class="flex-col justify-start relative page" @click="closeshow">
    <div class="flex-col justify-start items-center">
      <img class="imagebg" src="https://immortalcq.oss-cn-chengdu.aliyuncs.com/static/imglv1/loginBg.png" />
      <div class="inpm">
        <div class="inp">
          <input type="text" ref="inputField" placeholder="请输入ID号" @keyup.enter="handleEnter" v-model="id">
          <div class="mouban" v-if="type == 'app'" @click.stop="clickboard"></div>
        </div>
        <div class="jrsk" @click="submit">
          进入时空
        </div>

        <div class="virtual-keyboard" v-if="show" ref="targetElement">
          <customKeyboard @renewal="renewal" :oldid="id"></customKeyboard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import customKeyboard from "@/components/customKeyboard/index.vue"
import { departedinfo } from "@/api/go";
export default {
  components: {
    customKeyboard
  },
  beforeRouteEnter(to, from, next) {
    let s = to.query.s;
    if (s) {
      if (s == 1) {
        next({
          name: "index",
          query: to.query
        });
      } else if (s == 2) {
        next({
          name: "farewell",
          query: to.query
        });
      } else if (s == 3) {
        next();
      }
    } else {
      next();
    }
  },
  data() {
    return {
      id: '',
      hasTools: !this.$route.query.s,
      motif: 1,
      show: false,
      type: ''
    };
  },
  mounted() {
    this.motif = localStorage.getItem('motif') || 1
    //页面加载后，移动到默认焦点
    // this.$service.move(this.$service.pointer)
  },
  computed: {

  },
  watch: {

  },
  methods: {
    closeshow() {
      if(this.show){
        this.show = false
      }
    },
    clickboard() {
      this.show = true
    },
    renewal(id) {
      this.id = id
    },
    // 回车触发
    handleEnter() {
      this.$refs.inputField.select();
    },
    submit() {
      if (!this.id) {
        this.$message('id不能为空');
        return
      }

      this.$router.replace({
        name: "list",
        query: {
          id: this.id
        }
      });


    }
  },
  created() {
    this.type = this.$route.query.type
  }
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 100vh;
}

.imagebg {
  width: 100vw;
  height: 100vh;
}

.inpm {
  position: absolute;
  left: 40%;
  top: 53%;
  transform: translate(-50%, -50%);

  .inp {
    width: 432px;
    height: 68px;
    position: relative;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    background: #fff;
    display: flex;
    align-items: center;

    input {
      padding-left: 24px;
      border: none;
      font-size: 22px;
    }

    .mouban {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 999;
    }
  }

  .jrsk {
    margin-top: 42px;
    width: 163px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    font-size: 18px;
    color: #fff;
    background: #110B07;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    cursor: pointer;
  }
}

.opc {
  opacity: 0;
}

.zinde0 {
  z-index: -1 !important;
}

.virtual-keyboard {
  position: absolute;
  top: 30px;
  right: 0;
  z-index: 9999;
}
</style>